document.querySelectorAll('.mega-menu').forEach(function(menu) {
  if (menu.querySelector('.mega-menu-description')) {
    menu.classList.add('mega-menu--has-extra');
  }
});

document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.toggle-category-more');
  if (!toggle) return;

  e.preventDefault();

  const more = toggle.previousElementSibling;
  if (!more || !more.classList.contains('category-more')) return;

  const isOpen = toggle.getAttribute('aria-expanded') === 'true';

  if (isOpen) {
    more.style.maxHeight = '0';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Voir plus';
  } else {
    more.style.maxHeight = more.scrollHeight + 'px';
    toggle.setAttribute('aria-expanded', 'true');
    toggle.textContent = 'Voir moins';
  }
});

if (window.location.pathname === '/collections/personnalisation') {
  document.querySelectorAll('span.metafield-multi_line_text_field').forEach(span => {
    // Nettoyer le contenu : <br> → \n, décoder les entités HTML
    const raw = span.innerHTML
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&nbsp;/g, ' ')
      .trim();

    let pictos;
    try {
      pictos = JSON.parse(raw);
    } catch (e) {
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'pictos-list';

    pictos.forEach(({ nom, url }) => {
      const item = document.createElement('div');
      item.className = 'pictos-item';
      item.innerHTML = `<img src="${url}" alt="${nom}"><span>${nom}</span>`;
      wrapper.appendChild(item);
    });

    span.replaceWith(wrapper);
  });
}

if (window.innerWidth >= 990) {
  const primaryUl = document.querySelector('.header__primary-nav ul');
  const secondaryUl = document.querySelector('.header__secondary-nav ul');

  if (primaryUl && secondaryUl) {
    const items = primaryUl.querySelectorAll(':scope > li');
    const last2 = Array.from(items).slice(-2);

    last2.reverse().forEach(li => {
      li.remove();
      secondaryUl.prepend(li);
    });
  }
}

function initTooltip() {
  const hasCollection = [...document.body.classList].some(c => c.startsWith('collection-bague'));

  if (hasCollection) {
    document.querySelectorAll('.accordion__toggle').forEach(function(toggle) {
      const text = toggle.querySelector('.text-with-icon');
      if (text && text.textContent.trim().includes('Tour de doigt') && !text.dataset.tooltipInit) {
        
        text.dataset.tooltipInit = 'true';

        const accordion = toggle.closest('accordion-disclosure');
        if (!accordion) return;

        accordion.style.position = 'relative';

        const tooltip = document.createElement('span');
        tooltip.textContent = 'Mise à taille possible';
        tooltip.style.cssText = `
          display: none;
          position: absolute;
          background: #132a19;
          color: #fff;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 0.75rem;
          white-space: nowrap;
          top: -20px;
          left: 0;
        `;
        
        accordion.appendChild(tooltip);
        
        accordion.addEventListener('mouseenter', () => tooltip.style.display = 'block');
        accordion.addEventListener('mouseleave', () => tooltip.style.display = 'none');
      }
    });
  }
}

initTooltip();

const observer = new MutationObserver(() => initTooltip());
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', () => {
  const buyButton = document.querySelector('buy-buttons button[disabled]');
  
  if (buyButton) {
    const almaBlock = document.querySelector('[data-block-id*="alma_widget"]');
    if (almaBlock) {
      almaBlock.closest('.product-info__block-item').style.display = 'none';
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.add-mise-a-taille');
  const select = document.getElementById('mise-a-taille-select');
  if (!btn || !select) return;

  // Caché par défaut
  btn.style.display = 'none';

  select.addEventListener('change', () => {
    btn.style.display = select.value ? '' : 'none';
  });

  btn.addEventListener('click', async () => {
    if (!select.value) return;

    btn.disabled = true;
    btn.textContent = 'Ajout en cours...';

    try {
      const currentVariantId = parseInt(document.querySelector('[name="id"]')?.value);
      const variantSku = window.ShopifyAnalytics?.meta?.product?.variants?.find(
        v => v.id === currentVariantId
      )?.sku || '';
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(select.value),
          quantity: 1,
          properties: {
            'Produit ': document.querySelector('.product-title')?.textContent.trim(),
            'Référence ': variantSku
          }
        })
      });

      btn.textContent = 'Ajouté ✓';
      // Dispatcher un event pour rafraîchir le drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        document.getElementById('cart-drawer')?.show?.();
      }, 500);

      setTimeout(() => {
        btn.textContent = 'Ajouter';
        btn.disabled = false;
      }, 2000);

    } catch (e) {
      btn.textContent = 'Erreur, réessayer';
      btn.disabled = false;
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);
  const query = params.get('q') || '';
  
  const isSkuSearch = /^ref\d+$/i.test(query) || /^\d+$/.test(query);
  
  if (!isSkuSearch && (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search'))) {
    const checkbox = document.getElementById('facets-sidebar-filter.v.availability');
    if (checkbox && !checkbox.checked) {
      checkbox.click();
    }
  }
});